import { updateAppKemState } from "@ch/redux-store/kem/actions";
import type { AppState } from "@ch/redux-store/root-reducer";
import { type FC, useCallback, useEffect, useState } from "react";
import { Joyride, STATUS } from "react-joyride";
import { useDispatch, useSelector } from "react-redux";
import kemTourSteps from "../utils/KemTourSteps";
import KemTourTooltip from "./KemTourTooltip";

const KemTour: FC = () => {
  const dispatch = useDispatch();
  const completedOnboardingTourV1 = useSelector(
    (state: AppState) => state.kem.completedOnboardingTourV1,
  );
  const [runTour, setRunTour] = useState(false);

  // auto-start tour with delay if not completed
  useEffect(() => {
    if (completedOnboardingTourV1) return undefined;
    const timeoutId = setTimeout(() => {
      setRunTour(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, [completedOnboardingTourV1]);

  // Handle tour completion
  const handleTourCallback = useCallback(
    ({ status }: { status: string }) => {
      if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
        dispatch(updateAppKemState({ completedOnboardingTourV1: true }));
        setRunTour(false);
      }
    },
    [dispatch],
  );

  return (
    <Joyride
      continuous
      onEvent={handleTourCallback}
      options={{
        skipScroll: true,
        showProgress: true,
        buttons: ["primary", "skip"],
        zIndex: 10000,
      }}
      run={runTour}
      scrollToFirstStep
      steps={kemTourSteps}
      styles={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
      }}
      tooltipComponent={KemTourTooltip}
    />
  );
};

export default KemTour;
